import React, { useState, useEffect } from "react";
import { Col, Row, Typography } from "antd";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useParams } from "react-router-dom";
import { getTestimonialDatabyId } from "../../../services/holiday/holidayServices";

const { Title, Link } = Typography;

const Testmonial = () => {
  const { id } = useParams();
  const [testimonialData, setTestimonialData] = useState([]);
  const [reviewData, setReviewData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [cleanedId, setCleanedId] = useState("");

  useEffect(() => {
    if (id) {
      const cleaned = id.replace("-holiday-packages", "");
      setCleanedId(cleaned);
    }
  }, [id]);

  useEffect(() => {
    if (!cleanedId) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await getTestimonialDatabyId("testimonial", cleanedId);

        // Normalize response into array
        const data = res?.data || res;
        if (Array.isArray(data)) {
          setTestimonialData(data);
        }
        else if (data) {
          setTestimonialData([data]);
        }
        else {
          setTestimonialData([]);
        }
      } catch (error) {
        setError(error.message || "Error while fetching testimonials");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [cleanedId]);

  useEffect(() => {
    if (!cleanedId) return;

    const fetchReviewData = async () => {
      try {
        setLoading(true);
        const res = await getTestimonialDatabyId("review", cleanedId);

        // Normalize response into array
        const data = res?.data || res;
        if (Array.isArray(data)) {
          setReviewData(data);
        }
        else if (data) {
          setReviewData([data]);
        }
        else {
          setReviewData([]);
        }
      } catch (error) {
        setError(error.message || "Error while fetching Review");
      } finally {
        setLoading(false);
      }
    };

    fetchReviewData();
  }, [cleanedId]);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {(reviewData?.length > 0 ) && (
      <section className="Testimonial-area ptb-70">
        <div className="container">
          <div className="section-title">
            <div>
              <Title level={2} className="mb-0 offer-card__text box-title">
                Testimonials
              </Title>
              <span className="top-title">What our Customers Say About us</span>
            </div>
          </div>

          <Row gutter={20} className="justify-content-center">
            <Col md={24} xs={24}>
              <Slider {...settings}>
                {reviewData?.map((item, index) => (
                  <div key={index} style={{ margin: "0 10px" }}>
                    <div className="Testimonial-item">
                      <div className="single-testimonial">
                        <div className="round-1 round"></div>
                        <div className="round-2 round"></div>
                        <div className="client-info">
                          <div className="client-video">
                            <a href="#">
                              <h4>{item?.rating}</h4>
                            </a>
                          </div>
                          <div className="client-details">
                            <h6>{item?.name}</h6>
                          </div>
                        </div>
                        <p>
                          {item.content
                            ?.replace(
                              /<\/?p>/g,
                              ""
                            )
                            .trim()}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
                {reviewData?.map((item, index) => (
                  <div key={index} style={{ margin: "0 10px" }}>
                    <div className="Testimonial-item">
                      <div className="single-testimonial">
                        <div className="round-1 round"></div>
                        <div className="round-2 round"></div>
                        <div className="client-info">
                          <div className="client-video">
                            <a href="#">
                              <h4>{item?.rating}</h4>
                            </a>
                          </div>
                          <div className="client-details">
                            <h6>{item?.name}</h6>
                          </div>
                        </div>
                        <p>
                          {item.content
                            ?.replace(
                              /<\/?p>/g,
                              ""
                            )
                            .trim()}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
                
                {reviewData?.map((item, index) => (
                  <div key={index} style={{ margin: "0 10px" }}>
                    <div className="Testimonial-item">
                      <div className="single-testimonial">
                        <div className="round-1 round"></div>
                        <div className="round-2 round"></div>
                        <div className="client-info">
                          <div className="client-video">
                            <a href="#">
                              <h4>{item?.rating}</h4>
                            </a>
                          </div>
                          <div className="client-details">
                            <h6>{item?.name}</h6>
                          </div>
                        </div>
                        <p>
                          {item.content
                            ?.replace(
                              /<\/?p>/g,
                              ""
                            )
                            .trim()}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
                
                {reviewData?.map((item, index) => (
                  <div key={index} style={{ margin: "0 10px" }}>
                    <div className="Testimonial-item">
                      <div className="single-testimonial">
                        <div className="round-1 round"></div>
                        <div className="round-2 round"></div>
                        <div className="client-info">
                          <div className="client-video">
                            <a href="#">
                              <h4>{item?.rating}</h4>
                            </a>
                          </div>
                          <div className="client-details">
                            <h6>{item?.name}</h6>
                          </div>
                        </div>
                        <p>
                          {item.content
                            ?.replace(
                              /<\/?p>/g,
                              ""
                            )
                            .trim()}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>

              {/* <Slider {...settings}>
                <div style={{ margin: "0 10px" }}>
                  <div className="Testimonial-item">
                    <div className="single-testimonial">
                      <div className="round-1 round"></div>
                      <div className="round-2 round"></div>
                      <div className="client-info">
                        <div className="client-video">
                          <a href="#">
                            <h4>4.5</h4>
                          </a>
                        </div>
                        <div className="client-details">
                          <h6>Ruhi Sharma</h6>
                          <span>Trader and Investor</span>
                        </div>
                      </div>
                      <p>
                        As I visited Dubai last month with my family, I must say
                        that SuperbWorldTrip is a very professional and positive
                        agency as they were responsive and always available to
                        offer us the best services in Dubai. Thanks to them for
                        the safe and memorable trip to Dubai.
                      </p>
                    </div>
                  </div>
                </div>
                <div style={{ margin: "0 10px" }}>
                  <div className="Testimonial-item">
                    <div className="single-testimonial">
                      <div className="round-1 round"></div>
                      <div className="round-2 round"></div>
                      <div className="client-info">
                        <div className="client-video">
                          <a href="#">
                            <h4>4.5</h4>
                          </a>
                        </div>
                        <div className="client-details">
                          <h6>Akshay Khanna</h6>
                          <span>Businessman</span>
                        </div>
                      </div>
                      <p>
                        I reached out to Dubai with my friends, and we explored
                        many places there. Moreover, we tried out multiple
                        adventurous and fun-loving activities, and it was all
                        possible because of the SuperbWorldTrip.
                      </p>
                    </div>
                  </div>
                </div>
                <div style={{ margin: "0 10px" }}>
                  <div className="Testimonial-item">
                    <div className="single-testimonial">
                      <div className="round-1 round"></div>
                      <div className="round-2 round"></div>
                      <div className="client-info">
                        <div className="client-video">
                          <a href="#">
                            <h4>4.5</h4>
                          </a>
                        </div>
                        <div className="client-details">
                          <h6>Yeasin Arafat</h6>
                          <span>Designer, LLCG Team</span>
                        </div>
                      </div>
                      <p>
                        SuperbWorldTrip is fantastic and worth choosing an
                        agency. One of my friends referred me to choose their
                        services, and I am thankful to him as I am fully
                        satisfied with their services.
                      </p>
                    </div>
                  </div>
                </div>
              </Slider> */}
            </Col>
          </Row>
        </div>
      </section>
      )}
    </>
  );
};

export default Testmonial;
